module.exports = __webpack_public_path__ + "media/recipes/86-0cabb898.png";